import React from 'react';
import Button from 'Components/UI/Button';
import { getApexAccountCreationStatusColor, normalizeApexSyncStatus, PENDING_APEX_ACCOUNT_CREATION } from 'Consts/Apex';
import { makeStyles } from '@material-ui/core';
import useMobileLayout from 'Hooks/useMobileLayout';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  detailsButton: {
    width: 120,
    color: 'white',
    borderRadius: 15,
    boxShadow: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    detailsButton: {
      width: '100%',
      borderRadius: 4,
    },
  },
}));

export const DetailsButton = ({ resource, onClick, ...rest }) => {
  const classes = useStyles();
  const isPendingApexAccount = resource.attr('type') === PENDING_APEX_ACCOUNT_CREATION;
  const isMobile = useMobileLayout();

  const renderButton = () => {
    if (isPendingApexAccount) {
      return <ApexViewMoreButton />;
    }

    return <ViewMoreButton />;
  };

  const ApexViewMoreButton = () => {
    const normalizedStatus = normalizeApexSyncStatus(resource.attr('syncStatus'));
    const color = getApexAccountCreationStatusColor(normalizedStatus);

    return (
      <Button
        size={isMobile ? 'medium' : 'small'}
        variant="contained"
        style={{
          backgroundColor: color.iconColor,
        }}
        className={classes.detailsButton}
        disabled={resource.attr('disabled') === 'true'}
        onClick={onClick}
        test="managed-account-view-more-button"
        {...rest}
      >
        {resource.attr('syncStatus') === 'Complete' ? 'View More' : resource.attr('syncStatus')}
      </Button>
    );
  };

  const ViewMoreButton = () => {
    return (
      <Button
        size={isMobile ? 'medium' : 'small'}
        color="secondary"
        variant="contained"
        disabled={resource.attr('disabled') === 'true'}
        className={classes.detailsButton}
        onClick={onClick}
        test="managed-account-view-more-button"
        {...rest}
      >
        View More
      </Button>
    );
  };

  return (
    renderButton()
  );
};

DetailsButton.defaultProps = {
  onClick: () => {
  },
};

DetailsButton.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export const viewMore = {
  columnName: 'Click for Details',
  component: DetailsButton,
  onSubmit: () => {
  },
};

export default {
  viewMore,
};
